export default __webpack_public_path__ + "static/media/2.6620965b.jpg";